import React from 'react';
import { X, Check, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const AddressSelectorModal = ({ isOpen, onClose, addresses, selectedAddressId, onSelect }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="address-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Select Delivery Address</h3>
          <button type="button" onClick={onClose} className="modal-close-btn" aria-label="Close modal">
            <X size={20} />
          </button>
        </div>

        <div className="modal-body">
          {addresses && addresses.length > 0 ? (
            addresses.map((addr) => {
              const isActive = addr._id === selectedAddressId;
              return (
                <div
                  key={addr._id}
                  className={`modal-address-item ${isActive ? 'active' : ''}`}
                  onClick={() => {
                    onSelect(addr);
                    onClose();
                  }}
                >
                  <div className="address-item-details">
                    {addr.isDefault && (
                      <span className="address-badge-active">Default Address</span>
                    )}
                    <span className="address-item-title">{addr.shopName}</span>
                    <span className="address-item-subtitle">
                      Contact: {addr.contactPerson} | Phone: {addr.phone}
                    </span>
                    <p className="address-item-text">
                      {addr.street}, {addr.city}, {addr.state} - {addr.postalCode}, {addr.country}
                    </p>
                  </div>

                  <div className="address-radio-indicator">
                    {isActive && <Check size={10} color="#ff7a00" />}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="empty-addresses-state">
              <MapPin size={48} color="#a1a1aa" style={{ marginBottom: '16px' }} />
              <p>You have no saved addresses.</p>
              <Link to="/account" className="btn" style={{ fontSize: '0.9rem', padding: '10px 20px' }}>
                Go to Account to Add Address
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddressSelectorModal;
